// extracted by mini-css-extract-plugin
module.exports = {"activePresident":"ExploreContent_activePresident_3IOZb"};